import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { BaseComponent } from 'projects/shared/src/lib/shared/base/components/base-component';

@Component({
    selector: 'intello-website-callback',
    templateUrl: './callback.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        RouterModule
    ]
})
export class CallbackComponent extends BaseComponent implements OnInit {

    // -----------------------------------------------------------------------------------------------------
    // @ CONSTRUCTOR
    // -----------------------------------------------------------------------------------------------------

    constructor(private router: Router) { super(); }

    // -----------------------------------------------------------------------------------------------------
    // @ LIFE CYCLE HOOKS
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {
        this.router.navigateByUrl('/for-you');
    }
}
